<navbar-control #navbar></navbar-control>
<router-outlet></router-outlet>
<page-footer-control></page-footer-control>
<cookie-consent-control></cookie-consent-control>
